export default "__VITE_ASSET__fb754032__"